import React, {createContext, useContext, useState, useEffect} from 'react';
import {onSnapshot, query, collection} from "firebase/firestore";
import {getFirestore} from "firebase/firestore";
import {useUser} from "../UserContext.js";

const AdminContext = createContext();

export const useAdmin = () => {

  return useContext(AdminContext);
};

export const AdminProvider = ({children}) => {
  const [requests, setRequests] = useState([]);
  const [locates, setLocates] = useState([]);
  const {appUser} = useUser();

  // set locates observer when we have registered user
  useEffect(() => {
    let unsubscribe;
    async function getLocates() {
      const db = getFirestore();
      const locatesQuery = query(collection(db, "locates"));
      unsubscribe = onSnapshot(locatesQuery, (snapshot) => {
        const allLocates = snapshot.docs.map(doc => ({id: doc.id, ...doc.data()})).filter(doc =>
          doc.available !== undefined && doc.available !== null &&
          doc.created !== undefined && doc.created !== null &&
          doc.symbol !== undefined && doc.symbol !== null &&
          doc.total !== undefined && doc.total !== null &&
          doc.user !== undefined && doc.user !== null
        );
        setLocates(allLocates);
      }
      );
    }
    if (appUser) getLocates();
    else setLocates([]);
    return unsubscribe;
  }, [appUser]);

  // set requests observer when we have registered user
  useEffect(() => {
    let unsubscribe;
    async function getRequests() {
      const db = getFirestore();
      const requestsQuery = query(collection(db, "requests"));
      unsubscribe = onSnapshot(requestsQuery, (snapshot) => {
        const allDocuments = snapshot.docs.map(doc => ({id: doc.id, ...doc.data()}));
        const ordered = allDocuments.sort((a, b) => {
          return b.created - a.created;
        });
        // noneed to check forchanges, just set allDocuments
        setRequests(ordered);
      });
    }
    if (appUser?.role === "admin") getRequests();
    else setRequests([]);
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appUser]);

  // context returns
  // requests: array of all users' requests
  // locates: array of all locates
  const value = {
    requests,
    locates,
  };

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
};
